import { render, staticRenderFns } from "./five.vue?vue&type=template&id=67b96a8a&scoped=true"
import script from "./five.vue?vue&type=script&lang=js"
export * from "./five.vue?vue&type=script&lang=js"
import style0 from "./five.vue?vue&type=style&index=0&id=67b96a8a&prod&lang=less"
import style1 from "./five.vue?vue&type=style&index=1&id=67b96a8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b96a8a",
  null
  
)

export default component.exports